export function getAbsoluteUrl({
  basePath,
  path,
}: {
  basePath: string
  path: string
}) {
  const removeSlashes = (string: string) =>
    string?.replace(/^\/+/, '')?.replace(/\/$/, '')

  const protocol = process.env.NODE_ENV === 'development' ? 'http:' : 'https:'

  return `${protocol}//${
    removeSlashes(basePath) ||
    (typeof window !== 'undefined' && window?.location?.host)
  }/${removeSlashes(path)}`
}
